export enum StatAlertsStatus {
    OPEN = 0,
    INPROCESS = 1,
    COMPLETED = 2,
    CANCELLED = 3,
    DUPLICATE = 4,
}
